export default __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmWUlfBxc4EsA.woff2";